/*
 * StreamBank Monitoring v2.0.21
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {
    Fragment,
    useEffect,
    useRef,
    useState
} from 'react';
import {ModalBody, ModalFooter, Row, Col, FormControl, Form, Button} from 'react-bootstrap';

import Modal from '../Common/Modal';
import Conditional from "../Conditional";
import {SB_ENTER_KEY_CODE} from "../../Constants";
import AuthService from "../../Services/Core/AuthService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {KeyboardUtils} from "../../Utils/KeyboardUtils";

export const ForgotPasswordPopup = (props) => {
    
    const {
        authService = AuthService,
        centered,
        className,
        onHide = () => {},
        show,
        showDisabledWarning = false,
        showEmailField = true,
        suggestedEmail
    } = props;
    
    const usernameInputRef = useRef(null);

    const [email, setEmail] = useState(suggestedEmail ?? '');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [link, setLink] = useState()

    useEffect(() => {
        setEmail(suggestedEmail ?? '');
        if(show) {
            usernameInputRef.current?.focus();
            usernameInputRef.current?.select();
        }
    }, [show]);

    const submit = async (e) => {
        e.preventDefault(); // for keypress situation, prevent submitting the form.
        if(email) {
            try {
                const x = await authService.ForgotPassword(email);
                    if(x.success) {
                    setLink(x?.link);
                        setError('');
                        setSuccess(x?.message ?? "An email was sent to " + email);
                    // close();
                    } else {
                        setError( x.message || "Unknown error");
                    // close();
                    }
            } catch (x) {
                    setError(x?.data?.message ?? x?.message ?? "Unknown error");
            }
        }
    };

    const handleSuccessConfirmation = () => {
        setSuccess('');
        onHide();
    };

    return <Fragment>
        <Modal
            title="Success"
            size="md"
            body={[
                <p>{success}</p>,
                link && <p><a href={link}>click</a></p>,
            ]}
            footer={<Button variant="complete" onClick={handleSuccessConfirmation}>OK</Button>}
            show={!!success}
            onHide={() => handleSuccessConfirmation()}
            className={className}
            centered={centered}
        />
        <Modal
            title="Error"
            body={<p>{error}</p>}
            footer={<Button variant="complete" onClick={() => setError('')}>OK</Button>}
            show={!!error}
            onHide={() => setError('')}
            className={className}
            centered={centered}
        />
        <Modal
            title="Forgot Password"
            size="md"
            show={show && !error && !success}
            onHide={onHide}
            className={className}
            centered={centered}
        >
            <ModalBody>
                <Form>
                    <Row key={1}>
                        <Col xs={12}>
                            <p>
                                {
                                    !showEmailField ?
                                        ("Click 'Send Reset Password Email' to send a unique reset password link to " + email + "."):
                                        "Please enter your email and press 'Send Reset Password Email' to get a unique reset password link."
                                }
                            </p>
                        </Col>
                    </Row>
                    <Conditional Condition={showDisabledWarning}>
                        <Row key={3}>
                            <Col xs={12}>
                                <p className="sb-login-popup-container-error-message">This feature is disabled on this server.
                                    Please contact <a href="mailto:support@streambank.com">support@streambank.com</a> for
                                    assistance.</p>
                            </Col>
                        </Row>
                    </Conditional>
                    <Conditional Condition={showEmailField}>
                        <Row key={2}>
                            <Col md={3}>
                                <span>Email</span>
                            </Col>
                            <Col md={9}>
                                <FormControl
                                    autocomplete="username"
                                    type="text"
                                    name="text"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    onKeyDown={(e) => KeyboardUtils.handleKeyPress(SB_ENTER_KEY_CODE, e, (e) => submit(e))}
                                    ref={usernameInputRef}
                                />
                            </Col>
                        </Row>
                    </Conditional>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button variant="complete" onClick={submit}>
                    Send Reset Password Email
                </Button>
                <Button variant="link" className="ml-3" onClick={() => onHide()}>
                    <FontAwesomeIcon icon={['fal', 'times']} />
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    </Fragment>;
};

export default ForgotPasswordPopup;
